const win = window as unknown as {
  webkit?: {
    messageHandlers: {
      js_call: { postMessage: (msg: unknown) => void };
      js_notify: { postMessage: (msg: unknown) => void };
    };
  };
  onIosMessage?: (params: unknown) => void;
};

let seed = 0;
const handlers: {
  [k: string]: { resolve: (data: unknown) => void; reject: (error: string) => void };
} = {};

export const callIos = async (params: unknown) => {
  if (!win.webkit) {
    return;
  }

  try {
    const js_call_id = `m${seed}`;
    seed += 1;
    return new Promise((resolve, reject) => {
      handlers[js_call_id] = { resolve, reject };
      // oxlint-disable-next-line unicorn/require-post-message-target-origin -- WebKit messageHandler.postMessage doesn't accept targetOrigin
      win.webkit?.messageHandlers.js_call.postMessage({ js_call_id, params });
    });
  } catch (e: unknown) {
    // todo come up with more elegant solution
    // the actual error came from below, but adding a try/catch here as well as a precaution
  }
};

/**
 * Payload sent to the iOS native app via the WebKit message bridge.
 *
 * After the Sqids migration, `container_id` and `account_id` are opaque
 * Sqid strings. The native app MUST treat them as opaque identifiers —
 * never parsing as integers or performing arithmetic.
 */
export type IosNotifyNavPayload = {
  path: string;
  selected: {
    container_id: string | null;
    account_id: string | null;
    container_type: number | null;
    container_name: string;
    user_id: string | null;
    [key: string]: unknown;
  };
};

export type IosNotifyReadyPayload = {
  message_type: 'ready';
};

export type IosNotifyParams = IosNotifyNavPayload | IosNotifyReadyPayload;

export const notifyIos = (params: IosNotifyParams) => {
  if (!win.webkit) {
    return;
  }
  try {
    // oxlint-disable-next-line unicorn/require-post-message-target-origin -- WebKit messageHandler.postMessage doesn't accept targetOrigin
    win.webkit.messageHandlers.js_notify.postMessage({ params });
  } catch (e: unknown) {
    // todo come up with more elegant solution
  }
};

type JsCallResponse = {
  js_call_id: string;
  data?: unknown;
  error?: string;
};

export const initIos = (onIosMessage: (params: unknown) => void) => {
  win.onIosMessage = (params: unknown) => {
    if (
      params != null &&
      typeof params === 'object' &&
      'js_call_id' in params &&
      (params as JsCallResponse).js_call_id !== undefined
    ) {
      const { data, error, js_call_id } = params as JsCallResponse;
      const handler = handlers[js_call_id];
      if (!handler) {
        return;
      }
      if (error) {
        handler.reject(error);
      } else {
        handler.resolve(data);
      }
      delete handlers[js_call_id];
    } else {
      onIosMessage(params);
    }
  };
};
